// SearchInput.js
import React, { Component } from "react";
import { OutlinedInput, IconButton, Tooltip, Box, Divider, CircularProgress, InputAdornment, Badge } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import CommonValidation from "../CommonFunctions/CommonValidation";
import { localGetItem } from "../../Utility/Services/CacheProviderService";

class PatientHeaderSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.searchValue !== this.props.searchValue) {
      this.setState({ value: this.props.searchValue });
    }
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmed = CommonValidation.removeSpace(this.state.value);
      if (trimmed.length > 2) {
        this.props.onSearchSubmit(trimmed, this.props.module_name, this.props.FromFo);
      } else if (trimmed.length === 0) {
        this.props.onClear(this.props.module_name);
      }
    }
  };

  handleChange = (e) => {
    this.setState({ value: e.target.value });
  };

  render() {
    const { isLoading, t , filterVisible } = this.props;

    return (
      <OutlinedInput
        placeholder={t("SearchPatients")}
        onKeyDown={this.handleKeyDown}
        onChange={this.handleChange}
        value={this.state.value}
        size="small"
        className="eMed_header_Input"
        sx={{ width : (localGetItem('enable_other_doctor_list') === 'true') ? "15vw" : "23vw"}}
        endAdornment={
          <Box display="flex" flexDirection="row">
            <Divider orientation="vertical" variant="middle" flexItem />
            {isLoading ? (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "2.5vw" }}>
                <InputAdornment position="end">
                  <CircularProgress size={15} />
                </InputAdornment>
              </Box>
            ) : (
              <Tooltip title={t("Search")} arrow>
                <IconButton disabled={this.state?.value == ""} onClick={() => this.props.onSearchSubmit(this.state.value.trim(), this.props.module_name, this.props.FromFo)} position="end">
                  <SearchIcon />
                </IconButton>
              </Tooltip>
            )}
             { (this.props.module_name !== "Pharmacy" && this.props.module_name !== "Lab")  ? <Tooltip title={t("Filter")} arrow>
                <IconButton onClick={() => { this.props.flterOpen() }} position="end">
                    <Badge color="error" size='small' variant="dot" max={999} invisible={filterVisible}>
                        <FilterAltIcon />
                    </Badge>
                </IconButton>
            </Tooltip> : null}
            {this.props?.faceVisible ? <Tooltip title={t("FaceRecognition")} arrow>
            <IconButton onClick={() => { this.props.faceOpen(this.props?.module_name) }} position="end">
                <CenterFocusWeakIcon />
                </IconButton>
            </Tooltip> : null}
          </Box>
        }
      />
    );
  }
}

export default PatientHeaderSearch;
